import { useContext } from "react";
import { ShoppingCartContext } from "../Contexts/ShoppingCartProvider";

const useShoppingCart = () => {
    return useContext(ShoppingCartContext);
}

export default useShoppingCart;